/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_App_Feature_DietInputs */

const en_price_page_app_feature_diet = /** @type {(inputs: Price_Page_App_Feature_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calories from a photo of a meal`)
};

const pl_price_page_app_feature_diet = /** @type {(inputs: Price_Page_App_Feature_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalorie ze zdjęcia posiłku`)
};

/**
* | output |
* | --- |
* | "Calories from a photo of a meal" |
*
* @param {Price_Page_App_Feature_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_app_feature_diet = /** @type {((inputs?: Price_Page_App_Feature_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_App_Feature_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_app_feature_diet(inputs)
	return en_price_page_app_feature_diet(inputs)
});